import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _dependencies = /*#__PURE__*/new WeakMap();
var _startTime = /*#__PURE__*/new WeakMap();
var _pendingDependencies = /*#__PURE__*/new WeakMap();
var _onCompleteListeners = /*#__PURE__*/new WeakMap();
var _onDependencyCompleted = /*#__PURE__*/new WeakMap();
export default class TaskTracker {
  constructor(task) {
    _defineProperty(this, "task", void 0);
    _classPrivateFieldInitSpec(this, _dependencies, void 0);
    _classPrivateFieldInitSpec(this, _startTime, void 0);
    _classPrivateFieldInitSpec(this, _pendingDependencies, void 0);
    _classPrivateFieldInitSpec(this, _onCompleteListeners, void 0);
    _classPrivateFieldInitSpec(this, _onDependencyCompleted, void 0);
    this.task = task;
    _classPrivateFieldSet(_onCompleteListeners, this, []);
    _classPrivateFieldSet(_dependencies, this, []);
    _classPrivateFieldSet(_onDependencyCompleted, this, completedTask => {
      const {
        task: currentTask,
        success
      } = completedTask;
      if (!_classPrivateFieldGet(_startTime, this)) {
        return;
      }
      if (!success) {
        // a dependency has failed, so we must end the current task as a failure
        // end also takes care of cleanup
        this.failed(completedTask);
        return;
      }

      // remove the current dependency task from the pending list
      _classPrivateFieldSet(_pendingDependencies, this, _classPrivateFieldGet(_pendingDependencies, this).filter(dependency => dependency.task !== currentTask));

      // if all pending tasks have been completed (successfully), this task should also be marked complete
      if (_classPrivateFieldGet(_pendingDependencies, this).length === 0) {
        this.succeeded();
      }
    });
  }
  hasDependencies() {
    return _classPrivateFieldGet(_dependencies, this).length !== 0;
  }
  addCompletionListener(listener) {
    _classPrivateFieldGet(_onCompleteListeners, this).push(listener);
    return this;
  }
  start() {
    _classPrivateFieldSet(_startTime, this, performance.now());
    _classPrivateFieldSet(_pendingDependencies, this, _classPrivateFieldGet(_dependencies, this).map(dependency => dependency));
    return this;
  }

  /**
   * Call when the task is successfully completed. If this task has dependencies, it will
   * automatically be marked as successfully completed when _all_ of the dependencies also
   * successfully completed.
   */
  succeeded() {
    this._end(true);
  }

  /**
   * Call when the task fails. If this task has dependencies, it will automatically be marked as
   * failed if _any one_ of the dependencies also fail.
   */
  failed(cause, errorIdentifier) {
    this._end(false, cause, errorIdentifier);
  }

  /**
   * Call when the task needs to be aborted. This resets the state without triggering any "success"
   * or "failure" events.
   * Eg: For an App Listing page view task, if the used is redirected to the login page, the task
   * would need to be aborted since its neither a success not a failure.
   */
  abort() {
    if (typeof _classPrivateFieldGet(_startTime, this) !== 'number') {
      console.warn("[".concat(this.task, "] noop: Attempted to \"abort\" a task which wasn't started."));
      return;
    }
    _classPrivateFieldGet(_pendingDependencies, this).forEach(depdendency => depdendency.abort());
    this._resetState();
  }
  _end(success, cause, identifier) {
    const startTime = _classPrivateFieldGet(_startTime, this);
    if (typeof startTime !== 'number') {
      console.warn("[".concat(this.task, "] noop: Attempted to \"end\" a task which wasn't started."));
      return;
    }
    const duration = performance.now() - startTime;

    /* Metal doesn't provide an option to pass error identifier.
     * So, utilising taskId as a error identifier */
    _classPrivateFieldGet(_onCompleteListeners, this).forEach(listener => listener({
      task: this.task,
      taskId: identifier,
      success,
      cause,
      duration
    }));
    this._resetState();
    return this;
  }
  _resetState() {
    _classPrivateFieldSet(_startTime, this, null);
    _classPrivateFieldSet(_pendingDependencies, this, []);
    return this;
  }
  dependsOn(dependencies) {
    const hasNestedDependencies = dependencies.some(dependency => dependency.hasDependencies());
    if (hasNestedDependencies) {
      throw new Error("[".concat(this.task, "] task may not depend on sub-tasks which themselves have other dependencies"));
    }
    _classPrivateFieldSet(_dependencies, this, [...dependencies]);
    _classPrivateFieldGet(_dependencies, this).forEach(dependency => {
      dependency.addCompletionListener(_classPrivateFieldGet(_onDependencyCompleted, this));
    });
    return this;
  }
}